// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/pages/DetailPage.css */

.detail-hero {
  background-size: cover;
  background-position: center 20%;
  background-repeat: no-repeat;
  padding: 36px 0 28px;
  display: flex;
  justify-content: center;
}

.detail-hero-content {
  width: 100%;
  max-width: 1200px;
  padding: 0 clamp(16px, 4vw, 48px);
  display: flex;
  gap: 32px;
  align-items: flex-start;
}

.detail-poster {
  width: 220px;
  min-width: 220px;
  aspect-ratio: 2 / 3;
  object-fit: cover;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  border: 1px solid var(--border-strong);
}

.detail-info {
  color: var(--text);
  padding-bottom: 4px;
  flex: 1 1 auto;
  min-width: 0;
}

.detail-sidebar {
  flex: 0 0 190px;
  width: 190px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.detail-title {
  font-size: clamp(28px, 4vw, 44px);
  font-weight: 600;
  margin: 0 0 6px;
  text-shadow: 0 2px 12px rgba(0, 0, 0, 0.4);
}

.detail-tagline {
  font-style: italic;
  color: var(--text-muted);
  margin: 0 0 12px;
  font-size: 16px;
}

.detail-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  align-items: center;
  color: var(--text-muted);
  font-size: 14px;
  margin-bottom: 10px;
}

.detail-rating {
  color: var(--accent);
  font-weight: 600;
}

.detail-rating i {
  margin-right: 4px;
}

.detail-genres {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 14px;
}

.detail-genre-pill {
  padding: 5px 14px;
  border-radius: var(--radius-full);
  background: var(--surface);
  border: 1px solid var(--border);
  color: var(--text-muted);
  font-size: 12px;
}

.detail-overview {
  color: var(--text);
  line-height: 1.6;
  max-width: 640px;
  margin: 0 0 14px;
  font-size: 15px;
}

.detail-cast-director {
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.detail-cast-director p {
  margin: 0;
  font-size: 14px;
  color: var(--text-muted);
  max-width: 640px;
}

.detail-cast-director span {
  color: var(--text-faint);
  text-transform: uppercase;
  font-size: 11px;
  letter-spacing: 0.06em;
  margin-right: 8px;
}

.detail-actions {
  display: flex;
  gap: 12px;
}

.detail-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border-radius: var(--radius-full);
  text-decoration: none;
  font-size: 14px;
  font-weight: 600;
  border: 1px solid var(--border-strong);
  color: var(--text);
  transition: all var(--fast) var(--ease);
}

.detail-button:hover {
  background: var(--surface-hover);
  transform: translateY(-1px);
}

.detail-button.primary {
  background: linear-gradient(120deg, var(--accent-start), var(--accent-end));
  border: none;
  color: #1a0e05;
}

.detail-button.primary:hover {
  box-shadow: var(--shadow-accent);
}

.detail-stats {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 clamp(16px, 4vw, 48px) 8px;
}

.detail-stat {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 10px 14px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.detail-stat-label {
  color: var(--text-faint);
  text-transform: uppercase;
  font-size: 11px;
  letter-spacing: 0.06em;
}

.detail-stat-value {
  color: var(--text);
  font-size: 16px;
  font-weight: 600;
}

.detail-keywords {
  margin-top: 0;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 10px 14px;
}

.detail-keywords p {
  margin: 6px 0 0;
  color: var(--text-muted);
  font-size: 14px;
  text-transform: capitalize;
}

.detail-recommended {
  padding-top: 0;
}

@media (max-width: 720px) {
  .detail-hero-content {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .detail-poster {
    width: 160px;
    min-width: 160px;
  }

  .detail-sidebar {
    width: 100%;
    flex-basis: auto;
  }

  .detail-meta,
  .detail-genres,
  .detail-actions {
    justify-content: center;
  }

  .detail-overview,
  .detail-cast-director p {
    max-width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/DetailPage.css"],"names":[],"mappings":"AAAA,6BAA6B;;AAE7B;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,4BAA4B;EAC5B,oBAAoB;EACpB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iCAAiC;EACjC,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,+BAA+B;EAC/B,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,wBAAwB;EACxB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,0BAA0B;EAC1B,+BAA+B;EAC/B,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,eAAe;EACf,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,iCAAiC;EACjC,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,2EAA2E;EAC3E,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;;;IAGE,uBAAuB;EACzB;;EAEA;;IAEE,eAAe;EACjB;AACF","sourcesContent":["/* src/pages/DetailPage.css */\n\n.detail-hero {\n  background-size: cover;\n  background-position: center 20%;\n  background-repeat: no-repeat;\n  padding: 36px 0 28px;\n  display: flex;\n  justify-content: center;\n}\n\n.detail-hero-content {\n  width: 100%;\n  max-width: 1200px;\n  padding: 0 clamp(16px, 4vw, 48px);\n  display: flex;\n  gap: 32px;\n  align-items: flex-start;\n}\n\n.detail-poster {\n  width: 220px;\n  min-width: 220px;\n  aspect-ratio: 2 / 3;\n  object-fit: cover;\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-lg);\n  border: 1px solid var(--border-strong);\n}\n\n.detail-info {\n  color: var(--text);\n  padding-bottom: 4px;\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.detail-sidebar {\n  flex: 0 0 190px;\n  width: 190px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.detail-title {\n  font-size: clamp(28px, 4vw, 44px);\n  font-weight: 600;\n  margin: 0 0 6px;\n  text-shadow: 0 2px 12px rgba(0, 0, 0, 0.4);\n}\n\n.detail-tagline {\n  font-style: italic;\n  color: var(--text-muted);\n  margin: 0 0 12px;\n  font-size: 16px;\n}\n\n.detail-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 14px;\n  align-items: center;\n  color: var(--text-muted);\n  font-size: 14px;\n  margin-bottom: 10px;\n}\n\n.detail-rating {\n  color: var(--accent);\n  font-weight: 600;\n}\n\n.detail-rating i {\n  margin-right: 4px;\n}\n\n.detail-genres {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 14px;\n}\n\n.detail-genre-pill {\n  padding: 5px 14px;\n  border-radius: var(--radius-full);\n  background: var(--surface);\n  border: 1px solid var(--border);\n  color: var(--text-muted);\n  font-size: 12px;\n}\n\n.detail-overview {\n  color: var(--text);\n  line-height: 1.6;\n  max-width: 640px;\n  margin: 0 0 14px;\n  font-size: 15px;\n}\n\n.detail-cast-director {\n  margin-bottom: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.detail-cast-director p {\n  margin: 0;\n  font-size: 14px;\n  color: var(--text-muted);\n  max-width: 640px;\n}\n\n.detail-cast-director span {\n  color: var(--text-faint);\n  text-transform: uppercase;\n  font-size: 11px;\n  letter-spacing: 0.06em;\n  margin-right: 8px;\n}\n\n.detail-actions {\n  display: flex;\n  gap: 12px;\n}\n\n.detail-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 20px;\n  border-radius: var(--radius-full);\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: 600;\n  border: 1px solid var(--border-strong);\n  color: var(--text);\n  transition: all var(--fast) var(--ease);\n}\n\n.detail-button:hover {\n  background: var(--surface-hover);\n  transform: translateY(-1px);\n}\n\n.detail-button.primary {\n  background: linear-gradient(120deg, var(--accent-start), var(--accent-end));\n  border: none;\n  color: #1a0e05;\n}\n\n.detail-button.primary:hover {\n  box-shadow: var(--shadow-accent);\n}\n\n.detail-stats {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 clamp(16px, 4vw, 48px) 8px;\n}\n\n.detail-stat {\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  padding: 10px 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.detail-stat-label {\n  color: var(--text-faint);\n  text-transform: uppercase;\n  font-size: 11px;\n  letter-spacing: 0.06em;\n}\n\n.detail-stat-value {\n  color: var(--text);\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.detail-keywords {\n  margin-top: 0;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  padding: 10px 14px;\n}\n\n.detail-keywords p {\n  margin: 6px 0 0;\n  color: var(--text-muted);\n  font-size: 14px;\n  text-transform: capitalize;\n}\n\n.detail-recommended {\n  padding-top: 0;\n}\n\n@media (max-width: 720px) {\n  .detail-hero-content {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n  }\n\n  .detail-poster {\n    width: 160px;\n    min-width: 160px;\n  }\n\n  .detail-sidebar {\n    width: 100%;\n    flex-basis: auto;\n  }\n\n  .detail-meta,\n  .detail-genres,\n  .detail-actions {\n    justify-content: center;\n  }\n\n  .detail-overview,\n  .detail-cast-director p {\n    max-width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
